/* eslint-disable max-len */
import React from 'react';

export const Ellipse2 = () => (
  <svg className="experience-block__ellipse" width="855" height="977" viewBox="0 0 855 977" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_f_418_477)">
      <path d="M-2.37641 302.553C-73.1027 324.601 -112.417 386.475 -123.234 414.656C-180.984 565.115 -24.6142 717.235 91.049 693.864C235.628 664.65 329.357 546.583 485.951 502.75C611.226 467.684 575.966 375.746 542.677 334.161C523.877 304.123 448.985 254.486 299.811 296.241C113.344 348.435 86.0314 274.992 -2.37641 302.553Z" fill="url(#paint0_linear_418_477)" fillOpacity="0.3" />
    </g>
    <defs>
      <filter id="filter0_f_418_477" x="-415.631" y="0.219238" width="1269.69" height="976.034" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="140" result="effect1_foregroundBlur_418_477" />
      </filter>
      <linearGradient id="paint0_linear_418_477" x1="-179" y1="680" x2="510.64" y2="383.538" gradientUnits="userSpaceOnUse">
        <stop stopColor="#ADFF5B" />
        <stop offset="1" stopColor="#5BFFFF" />
      </linearGradient>
    </defs>
  </svg>

);
